export class ScrollListItemModel {

    public id: number;
    public title: string;
    public subtitle: string;
    public icon: string;
    public rightIcon?: string;
    public description: string;
    public item: any;
    public selected: boolean;
    public highlighted: boolean;

    constructor(listItem: any = {}) {
        this.id = listItem.id || 0;
        this.title = listItem.title || '';
        this.subtitle = listItem.subtitle || '';
        this.icon = listItem.icon || '';
        this.rightIcon = listItem.rightIcon || '';
        this.description = listItem.description || '';
        this.item = listItem.item;
        this.selected = listItem.selected;
        this.highlighted = listItem.highlighted;
    }
}
